// src/App.js
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AppContent from "./AppContent";
import { SnackbarProvider } from "./context/SnackbarContext";
import { HomeFabProvider } from "./context/HomeFabContext";

function App() {
  return (
    <SnackbarProvider>
        <AuthProvider>
          <HomeFabProvider>
            <BrowserRouter>
                <AppContent />
            </BrowserRouter>
          </HomeFabProvider>
        </AuthProvider>
    </SnackbarProvider>
  );
}

export default App;
